export function detectTopic(query: string): string {
  const q = query.toLowerCase();
  if (/derivative|d\/dx|differentiat/.test(q)) return 'Derivatives';
  if (/integrat|integral/.test(q)) return 'Integrals';
  if (/\blimit\b|\blim\b/.test(q)) return 'Limits';
  if (/taylor|maclaurin/.test(q)) return 'Taylor Series';
  if (/\bfactor\b/.test(q)) return 'Factoring';
  if (/simplif/.test(q)) return 'Simplify';
  if (/\bexpand\b/.test(q)) return 'Expand';
  if (/\bsolve\b/.test(q)) return 'Equations';
  if (/mean|median|std.*dev|standard dev|variance|normal dist|binomial/.test(q)) return 'Statistics';
  if (/\bplot\b|\bgraph\b/.test(q)) return 'Plotting';
  if (/balance|molar mass|\bph\s+of|stoichiometry/.test(q)) return 'Chemistry';
  if (/\bconvert\b|\bto\s+(km|miles|kg|lbs|celsius|fahrenheit)/.test(q)) return 'Unit Conversion';
  if (/kinetic|momentum|ohm|newton|F\s*=\s*ma|potential energy/.test(q)) return 'Physics';
  if (/circle|sphere|cylinder|pythagorean|triangle area/.test(q)) return 'Geometry';
  return 'General';
}

export interface TopicStyle {
  dot: string;
  badge: string;
  badgeText: string;
}

export const TOPIC_STYLE: Record<string, TopicStyle> = {
  Derivatives:      { dot: '#7c3aed', badge: 'bg-violet-100 dark:bg-violet-900/30',  badgeText: 'text-violet-700 dark:text-violet-300' },
  Integrals:        { dot: '#0d9488', badge: 'bg-teal-100 dark:bg-teal-900/30',       badgeText: 'text-teal-700 dark:text-teal-300' },
  Limits:           { dot: '#d97706', badge: 'bg-amber-100 dark:bg-amber-900/30',     badgeText: 'text-amber-700 dark:text-amber-300' },
  'Taylor Series':  { dot: '#ea580c', badge: 'bg-orange-100 dark:bg-orange-900/30',   badgeText: 'text-orange-700 dark:text-orange-300' },
  Equations:        { dot: '#059669', badge: 'bg-emerald-100 dark:bg-emerald-900/30', badgeText: 'text-emerald-700 dark:text-emerald-300' },
  Factoring:        { dot: '#16a34a', badge: 'bg-green-100 dark:bg-green-900/30',     badgeText: 'text-green-700 dark:text-green-300' },
  Simplify:         { dot: '#0284c7', badge: 'bg-sky-100 dark:bg-sky-900/30',         badgeText: 'text-sky-700 dark:text-sky-300' },
  Expand:           { dot: '#0369a1', badge: 'bg-sky-100 dark:bg-sky-900/30',         badgeText: 'text-sky-700 dark:text-sky-300' },
  Statistics:       { dot: '#e11d48', badge: 'bg-rose-100 dark:bg-rose-900/30',       badgeText: 'text-rose-700 dark:text-rose-300' },
  Plotting:         { dot: '#db2777', badge: 'bg-pink-100 dark:bg-pink-900/30',       badgeText: 'text-pink-700 dark:text-pink-300' },
  Chemistry:        { dot: '#65a30d', badge: 'bg-lime-100 dark:bg-lime-900/30',       badgeText: 'text-lime-700 dark:text-lime-300' },
  'Unit Conversion':{ dot: '#06b6d4', badge: 'bg-cyan-100 dark:bg-cyan-900/30',       badgeText: 'text-cyan-700 dark:text-cyan-300' },
  Physics:          { dot: '#0891b2', badge: 'bg-cyan-100 dark:bg-cyan-900/30',       badgeText: 'text-cyan-700 dark:text-cyan-300' },
  Geometry:         { dot: '#dc2626', badge: 'bg-red-100 dark:bg-red-900/30',         badgeText: 'text-red-700 dark:text-red-300' },
  General:          { dot: '#64748b', badge: 'bg-slate-100 dark:bg-slate-700',        badgeText: 'text-slate-700 dark:text-slate-300' },
};
